<input #input matInput [value]="visibleValue" (input)="onInputChange($event)" (click)="onClick($event)" (keydown)="onKeyDown($event)" class="cuit-input" autocomplete="off" [disabled]="disabled">
